import FetchFactory from '../factory'

class DashboardModule extends FetchFactory<any> {
    async getJobRecommendation() {
        return await useAsyncData(() => {
            return super.call('/api/job-seeker/dashboard/job-recommendations', {
                method: 'GET',
      })
        })
    }

    async getSummary() {
        return await useAsyncData(() => {
            return super.call('/api/job-seeker/dashboard/summaries', {
                method: 'GET',
      })
        })
    }

    async getCandidateProgress() {
        return await useAsyncData(() => {
            return super.call('/api/job-seeker/dashboard/candidate-progress', {
                method: 'GET',
      })
        })
    }
}

export default DashboardModule
